<template>
  <div class="severityTag">
    <el-tag
      :type="severityItem.tag"
      effect="dark"
      :color="severityItem.color"
      size="mini"
    >{{ $t('severityTag.' + severityItem.label.toLowerCase()) }}</el-tag>
  </div>
</template>

<script>
const SeverityColorMap = [
  {
    tag: 'info',
    key: 'Critical',
    label: 'Critical',
    color: '#951d1d',
  },
  {
    tag: 'danger',
    key: 'High',
    label: 'High',
  },
  {
    tag: 'warning',
    key: 'Medium',
    label: 'Medium',
  },
  {
    tag: 'success',
    key: 'Low',
    label: 'Low',
  },
];

export default {
  name: 'SeverityTag',
  props: {
    severity: {
      type: String,
      required: true,
    },
  },
  computed: {
    severityItem() {
      return SeverityColorMap.find((item) => item.key === this.severity) || {};
    },
  },
};
</script>

<style lang="scss" scoped>
.severityTag {
  .el-tag {
    border: none;
  }
}
</style>